import TeamEmailsView from './TeamEmailsView';

export default TeamEmailsView;
